define(function(require, exports) {
    
    'use strict';

    function NavigationService($rootScope,$state,$stickyState,$previousState, $timeout, $window, $q, PlatformService, $http, lpPortal) {

        var _isNotMobileBasedOnSize =PlatformService._isNotMobileBaseOnSize;
        var _isNotMobile=PlatformService._isNotDevice;
        var states = [];


        $rootScope.previousState = states;

        window.addEventListener("orientationchange", function(requestedState) {
            setTimeout(function(){
                if (window.matchMedia("(orientation: portrait)").matches) {

                   $('.nb-pop-up .modal-content').addClass('portrait-css');
                   $('.nb-pop-up .modal-header').css("display", "block");
                }
                else if (window.matchMedia("(orientation: landscape)").matches) {

                     $('.nb-pop-up .modal-content').removeClass('portrait-css');
                }
            },200);
        });


         gadgets.pubsub.subscribe("showPopupTitle", function(data){
            if(data){
                $('.modal-header').addClass('modal-show-titile-ie');
            }
            else {
                $('.modal-header').removeClass('modal-show-titile-ie');
            }
         });

        var logOut = function() {
            var requestUrl = lpPortal.root+'/j_spring_security_logout?portalName=' + lpPortal.name;
            var request = {
                url : requestUrl,
                method: 'POST'
            }
            $http(request).then(onSuccess, onError);
            function onSuccess(response) {
                if(response.status == 200) {
                    $window.sessionStorage.clear();
                    $window.location.href =  b$.portal.urlRedirect+'/login';
                }
            }
            function onError(response) {
            }
        };

        var resetState=function(state){

            if(typeof state =="string"){
                $stickyState.reset(state)
            }else{
               var length = state.length;
               for(var i=0;i<length;i++){
                $stickyState.reset(state[i]);
               }
            }

        }
        var openPopup=function(requestedState){
            $rootScope.$emit('popup-triger',requestedState);
        }

        var doBack = function() {
             var current = $state.current;

             console.debug("Back is intiated with onBack as ",current.onBack);
             if(b$.portal.popUpOpened){
                 var useGoBackDir = false;
                 gadgets.pubsub.publish("POPUP_GO_BACK",{"useGoBackDir":useGoBackDir});
             }
             var nextState = undefined
            if (current.onBack) {
                while (nextState == undefined && $rootScope.previousState.length != 0) {
                    var tempState = $rootScope.previousState.pop();
                    console.debug("State popped from history",tempState);
                    if(typeof current.onBack == 'string'){
                    if (tempState.name == current.onBack || tempState.alias == current.onBack) {
                        nextState = tempState.name;
                    }
                    }else{
                        if (current.onBack.includes(tempState.name) || (current.onBack.includes(tempState.alias))) {
                            nextState = tempState.name;
                        }
                    }
                }

            }
            var oldState = undefined
            if (current.onBack && !nextState && $rootScope.previousState.length == 0) {
                console.debug("on Back is present, but not found in local history popped from history, hence calling Native back for immediate back",tempState)
                gadgets.pubsub.publish('NO_MORE_HISTORY', {})
                var widgetToNavigate=getLastUsedWidget(current.onBack,null)

                gadgets.pubsub.publish(widgetToNavigate, {
                    title: widgetToNavigate,
                    data: {},
                    events:current.events
                });
            } else if (nextState) {
                console.debug("On Back is found state was found in history ",nextState);
                oldState = nextState;
            }

            if (oldState == undefined) {
                oldState = $rootScope.previousState.pop();
                console.debug("On Back param not found hence navigating to previous history state",oldState);

            }
            if ($rootScope.previousState.length == 0) {
                console.debug("No more previous state , hence publishing no_more_history");
                gadgets.pubsub.publish('NO_MORE_HISTORY', {})
            }
            if (oldState) {
                $state.dontStoreInHistory = true;

                var oldStateJson =$state.get(oldState)
                if(oldStateJson.mode){
                    var desktopMode= oldStateJson.mode.desktop;
                    if(_isNotMobileBasedOnSize() && desktopMode=="popup"){
                        openPopup(oldStateJson)
                    }
                    else{
                        $rootScope.$emit('popup-close',{});
                        if(desktopMode=="popup"){
                            $('.bp-area.c-template-hdfc-2-7-3--area.col-xs-12.col-sm-4.col-md-3.col-lg-3.right-side-scroll-fix.clearfix').hide();
                            $('.bp-area.tempate-hdfc-nb-273-profile--area.col-xs-12.col-sm-3.col-md-3.col-lg-3.right-side-scroll-fix.clearfix').hide();
                            $('.B-template-hdfc-footer--area').hide();
                            $('.lp-widget-hdfc-demat-ticker').hide();
                        }else{
                            $('.bp-area.c-template-hdfc-2-7-3--area.col-xs-12.col-sm-4.col-md-3.col-lg-3.right-side-scroll-fix.clearfix').show();
                            $('.bp-area.tempate-hdfc-nb-273-profile--area.col-xs-12.col-sm-3.col-md-3.col-lg-3.right-side-scroll-fix.clearfix').show();
                            $('.lp-widget-hdfc-demat-ticker').show();
                            $('.B-template-hdfc-footer--area').show();
                        }
                        goToInternalState(oldStateJson);
                    }
                }else{
                    $rootScope.$emit('popup-close',{});
                    sessionStorage.removeItem('popuptriggedandopened');
                    $('.bp-area.c-template-hdfc-2-7-3--area.col-xs-12.col-sm-4.col-md-3.col-lg-3.right-side-scroll-fix.clearfix').show();
                    $('.bp-area.tempate-hdfc-nb-273-profile--area.col-xs-12.col-sm-3.col-md-3.col-lg-3.right-side-scroll-fix.clearfix').show();
                    $('.lp-widget-hdfc-demat-ticker').show();
                    $('.B-template-hdfc-footer--area').show();
                    $state.go(oldStateJson,{},{location:false});
                }
                rapportBackData(oldState);
            }
            else {
                if (typeof cxp !== "undefined") {
                    gadgets.pubsub.publish("onBackPressEvent");
                } else {
                    sessionStorage.setItem('allowReload', true);
                    $window.history.go(-1);
                }
            }
        }

        var goToExternalState=function(args){
            if(_isNotMobile()){
                if(args.data)
                 {sessionStorage.setItem("transactionData",JSON.stringify(args.data));}
                 sessionStorage.setItem('allowReload', true);
                 $window.location.assign(args.link);
            }else{
                var dataToBeSent={};
                dataToBeSent.wrapper=args.data;
                var widgetToGo =args.state;

                var re=new RegExp(PlatformService.getWidgetName()+".");
                if(re.test(widgetToGo))
                {widgetToGo=widgetToGo.replace(PlatformService.getWidgetName()+".","");}

                gadgets.pubsub.publish(widgetToGo, {title: widgetToGo,state:args.startState,data:dataToBeSent,events:args.events});
            }
        }

        var closePopup=function(data){
            if(b$.portal.popUpOpened){
                var useGoBackDir = false;
                gadgets.pubsub.publish("POPUP_GO_BACK",{"useGoBackDir":useGoBackDir});
            }
            sessionStorage.removeItem('popuptriggedandopened');
            $rootScope.$emit('popup-close',{'value':data});
            if(!$previousState.get("MAIN-COVER") && ($previousState.get().state.title === 'Login')){
                var activeState = $previousState.get();
            }else{
                var activeState = $previousState.get("MAIN-COVER");
            }
            var x = $rootScope.previousState.length;
            for(var i=x; i>0; i--){
                var previous = $rootScope.previousState[i-1];
                if(previous.name != activeState.state.name){
                    $rootScope.previousState.pop();

                    if(typeof $state.current.events !== 'undefined' && $state.current.events.RESET_PREV_STATE){
                        resetState(activeState.state.name);
                    }
                }else{
                    break;
                }
            }

            if(activeState){
                if($state.current.name!=activeState.state.name){

                    console.debug("setting dont store in history flag as Popup is being closed, and previous main state is made active",activeState);
                    $state.dontStoreInHistory = true;
                    $state.go(activeState.state,{},{location:false});
                }
                else{
                    console.debug("close of popup already triggered , hecne dropping call silently");
                }
            }
        }

        var goToInternalState=function(requestedState,resetState){
            $state.forwardCall=true;
            $stickyState.reset(requestedState.name)
            if(b$.portal.popUpOpened){
                var useGoBackDir = false;
                gadgets.pubsub.publish("POPUP_GO_BACK",{"useGoBackDir":useGoBackDir});
            }
            $state.go(requestedState,{},{location:false});
        }

        var go=function(){
            var length = arguments.length;
            var navObj = undefined;
            if(length == 1 && $window.angular.isObject(arguments[0])){
            navObj=arguments[0];
            }else{
                navObj ={};
                if(arguments[0]){

                    var re=new RegExp(PlatformService.getWidgetName()+".");
                    if(re.test(arguments[0]))
                        navObj.state=arguments[0]
                    else {
                        navObj.state=PlatformService.getWidgetName()+"."+arguments[0];
                    }

                }
                if(arguments[1]){
                    navObj.link=arguments[1];
                }
                if(arguments[2]){
                    navObj.data=arguments[2]
                }
                if(arguments[3]){
                    navObj.startState=arguments[3]
                }
                if(arguments[4]){
                    navObj.reset=arguments[4]
                }
            }
            if(b$.portal.popUpOpened){
                var useGoBackDir = false;
                gadgets.pubsub.publish("POPUP_GO_BACK",{"useGoBackDir":useGoBackDir});
            }
            var requestedState=$state.get(navObj.state);

            if(requestedState==undefined){
                goToExternalState(navObj);
                return;
            }
            else{
                var mode = ((requestedState.mode)? requestedState.mode.desktop : "none")
                sessionStorage.setItem('popuptriggedandopened', mode);
                if(_isNotMobileBasedOnSize() && mode=="popup"){
                    openPopup(requestedState)
                }else{
                    $rootScope.$emit('popup-close',{});
                    if(mode=="popup"){
                        $('.bp-area.c-template-hdfc-2-7-3--area.col-xs-12.col-sm-4.col-md-3.col-lg-3.right-side-scroll-fix.clearfix').hide();
                        $('.bp-area.tempate-hdfc-nb-273-profile--area.col-xs-12.col-sm-3.col-md-3.col-lg-3.right-side-scroll-fix.clearfix').hide();
                        $('.lp-widget-hdfc-demat-ticker').hide();
                        $('.B-template-hdfc-footer--area').hide();

                    }else{
                        $('.bp-area.c-template-hdfc-2-7-3--area.col-xs-12.col-sm-4.col-md-3.col-lg-3.right-side-scroll-fix.clearfix').show();
                        $('.bp-area.tempate-hdfc-nb-273-profile--area.col-xs-12.col-sm-3.col-md-3.col-lg-3.right-side-scroll-fix.clearfix').show();
                        $('.lp-widget-hdfc-demat-ticker').show();
                        $('.B-template-hdfc-footer--area').show();

                    }
                    goToInternalState(requestedState,navObj.reset);
                }
            }
        }

        var publish=function(eventName,data){
            gadgets.pubsub.publish(eventName,data);
        }

        var subscribe=function(eventName,callBack){
            gadgets.pubsub.subscribe(eventName,callBack);
        }

        var getNavData =function(){
            return $state.get($state.current.name).$extras;
        }

        var getLastUsedWidget=function(widgetNames,cb){
            if(typeof widgetNames == 'string'){
                widgetNames=[widgetNames]
            }
            var length = widgetNames.length;
            var resultArray=[];
            for(var i=0;i<length;i++){
                var timeOfWidgetLoad=sessionStorage.getItem( "ent-"+widgetNames[i]);
                if(timeOfWidgetLoad){
                resultArray.push({
                    name:widgetNames[i],
                    time:timeOfWidgetLoad
                })
                }
                if(resultArray.length > 0){
                    resultArray.sort(function(a,b){return parseFloat(a.time)-parseFloat(b.time)});
                    if(cb){
                        cb(resultArray.pop())
                    }else{
                        return resultArray.pop();
                    }
                }else{
                    if(cb){
                        cb(null)
                    }else{
                        return null;
                    }
                }
            }
        }

        var anchorScroll = function(eID) {
             var startY = currentYPosition();
             var stopY = elmYPosition(eID);
             var distance = stopY > startY ? stopY - startY : startY - stopY;
             if (distance < 100) {
                 scrollTo(0, stopY); return;
             }
             var speed = Math.round(distance / 100);
             if (speed >= 20) speed = 20;
             var step = Math.round(distance / 25);
             var leapY = stopY > startY ? startY + step : startY - step;
             var timer = 0;
             if (stopY > startY) {
                 for ( var i=startY; i<stopY; i+=step ) {
                     setTimeout("window.scrollTo(0, "+leapY+")", timer * speed);
                     leapY += step; if (leapY > stopY) leapY = stopY; timer++;
                 } return;
             }
             for ( var j=startY; j>stopY; j-=step ) {
                 setTimeout("window.scrollTo(0, "+leapY+")", timer * speed);
                 leapY -= step; if (leapY < stopY) leapY = stopY; timer++;
             }

             function currentYPosition() {

                 if (self.pageYOffset) return self.pageYOffset;

                 if (document.documentElement && document.documentElement.scrollTop){
                    return document.documentElement.scrollTop;
                 }

                 if (document.body.scrollTop) return document.body.scrollTop;
                 return 0;
             }

             function elmYPosition(eID) {
                 var elm = document.getElementById(eID);
                 var y = elm.offsetTop - 125;
                 var node = elm;
                 while (node.offsetParent && node.offsetParent != document.body) {
                     node = node.offsetParent;
                     y += node.offsetTop;
                 } return y;
             }
        };

        var rapportBackData = function(oldState) {
            var current = $state.current;
            if(oldState.title == 'dashboardLanding') {
                dispatchRapportData('DASH_LD');
            }else if (current.name == 'moneytransfer.own-account-transfer-confirm' && oldState.title == 'Money Transfer Landing') {
                dispatchRapportData('OWN_ACC_FTL');
            }else if (oldState.title == 'Money Transfer Landing') {
                dispatchRapportData('OTR_ACC_FTL');
            }else if (oldState.name == 'moneytransfer.AddPayee') {
                dispatchRapportData('ADP_LD');
            }else if (oldState.title == 'HDFC Payee Confirm') {
                dispatchRapportData('ADP_CNF');
            }
            else if (oldState.title == 'Non HdfcPayee Confirm') {
                dispatchRapportData('N_ADP_CNF');
            }
        }

        return {
            go: go,
            back: doBack,
            publish:publish,
            subscribe:subscribe,
            getNavData:getNavData,
            closePopup:closePopup,
            getLastUsedWidget:getLastUsedWidget,
            resetState:resetState,
            logOut:logOut,
            anchorScroll:anchorScroll
        }

    }
    exports.NavigationService = NavigationService;
});


// WEBPACK FOOTER //
// ./src/feature-hdfc-navigation/scripts/service/NavigationalService.js